import VueCookie from 'vue-cookie';

const SESSION_KEY_NAME = 'AdvertisingParams';

export function getAdvertisingParamsFromSession() {
  let params = sessionStorage.getItem(SESSION_KEY_NAME);
  params = params ? JSON.parse(params) : {};

  Object.keys(params)
    .forEach((key) => {
      if (!params[key]) {
        delete params[key];
      }
    });

  const ga = VueCookie.get('_ga');
  if (ga) {
    params._ga = ga.replace(/(GA\d+\.\d+\.)/, '');
  }

  const fbp = VueCookie.get('_fbp');
  if (fbp) {
    params._fbp = fbp;
  }

  return params;
}

export function saveAdvertisingParamsToSession() {
  if (sessionStorage.getItem(SESSION_KEY_NAME)) {
    return {};
  }

  const urlParams = new URLSearchParams(document.location.search.substring(1));
  const paramsFromLS = localStorage.getItem(SESSION_KEY_NAME);
  let params = {};

  if (urlParams.get('email_verify_token')) {
    if (paramsFromLS) {
      params = JSON.parse(paramsFromLS);
      localStorage.removeItem(SESSION_KEY_NAME);
    } else {
      params = {};
    }
  } else {
    params = {
      content: urlParams.get('key_content') || urlParams.get('utm_content'),
      medium: urlParams.get('key_medium') || urlParams.get('utm_medium'),
      source: urlParams.get('key_source') || urlParams.get('utm_source'),
      campaign: urlParams.get('key_campaign') || urlParams.get('utm_campaign'),
      term: urlParams.get('key_term') || urlParams.get('utm_term'),
      gclid: urlParams.get('gclid'),
      fbclid: urlParams.get('fbclid'),
      edugram_id: urlParams.get('edugram_id'),
      type: urlParams.get('type'),
      click_id: urlParams.get('click_id'),
      subid: urlParams.get('subid'),
      subid1: urlParams.get('subid1'),
      subid2: urlParams.get('subid2'),
      subid3: urlParams.get('subid3'),
      subid4: urlParams.get('subid4'),
      _ga: VueCookie.get('_ga'),
      coupon: VueCookie.get('coupon'),
      referrer: document.referrer,
    };
  }

  Object.keys(params)
    .forEach((key) => {
      if (!params[key]) {
        delete params[key];
      }
    });

  if (Object.keys(params).length) {
    sessionStorage.setItem(SESSION_KEY_NAME, JSON.stringify(params));
    // Сохраняем параметры в localStorage, как фолбек, чтобы их можно было использовать
    // их на других вкладках, после подтверждения email
    if (!urlParams.get('email_verify_token')) {
      localStorage.setItem(SESSION_KEY_NAME, JSON.stringify(params));
    }
  }

  if (urlParams.get('key_campaign') !== 'brand' && Object.keys(params).length > 0) {
    sessionStorage.setItem('advertising_user', '1');
  }

  return params;
}
